export default {
  'Teklif Formu': 'ऑफर फॉर्म',
  'Kayıtlı Teklifler': 'सहेजे गए ऑफर',
  'Kullanıcı Adı': 'उपयोगकर्ता नाम',
  'Şifre': 'पासवर्ड',
  'Giriş Yap': 'लॉगिन करें',
  'Çıkış Yap': 'लॉगआउट करें',
  'KDV Oranı': 'जीएसटी दर',
  'Teklif Durumu': 'ऑफर स्थिति',
  'Kaydet': 'सहेजें',
  'PDF Önizleme': 'पीडीएफ पूर्वावलोकन',
  'PDF\'ye Aktar': 'पीडीएफ में निर्यात करें',
  'E-posta ile Gönder': 'ईमेल द्वारा भेजें',
  'Alıcı': 'प्राप्तकर्ता',
  'Tarih': 'तिथि',
  'Genel Toplam': 'कुल योग',
  'Not': 'टिप्पणी',
  'KDV': 'जीएसटी',
  'Alt Toplam': 'उप-योग',
  'Açıklama': 'विवरण',
  'Ürün Adı': 'उत्पाद नाम',
  'SUT Kodu': 'एसयूटी कोड',
  'Birim Alış Fiyatı': 'इकाई मूल्य',
  'Sipariş Adedi': 'ऑर्डर मात्रा',
  'Promosyon Ürün': 'प्रोमो उत्पाद',
  'Toplam Adet': 'कुल मात्रा',
  'Sipariş Tutarı': 'ऑर्डर राशि',
  'Durum': 'स्थिति',
  'Kabul Edildi': 'स्वीकृत',
  'Reddedildi': 'अस्वीकृत',
  'Gönderildi': 'भेजा गया',
  'Taslak': 'मसौदा',
  'Yurtiçi': 'घरेलू',
  'Yurtdışı': 'अंतर्राष्ट्रीय',
  'Sipariş Oluştur': 'ऑर्डर बनाएं',
  'Ürün Sıralaması': 'उत्पाद क्रमबद्धता',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'उत्पाद लोकप्रियता और महत्व स्तर के अनुसार क्रमबद्ध हैं',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'कार्डियोलॉजी और वास्कुलर सर्जरी उत्पाद प्राथमिकता के रूप में दिखाए जाते हैं',
  'Ürün adı, açıklama veya barkod ile ara...': 'उत्पाद नाम, विवरण या बारकोड से खोजें...',
  'Tüm Kategoriler': 'सभी श्रेणियां',
  'Kutu görünüm': 'ग्रिड दृश्य',
  'Liste görünüm': 'सूची दृश्य',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'आपके मानदंडों के अनुरूप कोई उत्पाद नहीं मिला',
  'Ürün Adı Yok': 'कोई उत्पाद नाम नहीं',
  'Kategori Yok': 'कोई श्रेणी नहीं',
  'Açıklama yok': 'कोई विवरण नहीं',
  'Firma Bilgilerini Doldurun': 'कंपनी जानकारी भरें',
  'Sepete Ekle': 'कार्ट में जोड़ें',
  'Firma Bilgileri': 'कंपनी जानकारी',
  'Ülke Seçimi': 'देश चयन',
  'Türkiye': 'तुर्की',
  'Almanya': 'जर्मनी',
  'ABD': 'यूएसए',
  'Firma Ünvanı': 'कंपनी नाम',
  'Vergi Dairesi': 'कर कार्यालय',
  'Vergi Numarası': 'पैन नंबर',
  'Adres': 'पता',
  'Şehir': 'शहर',
  'Şehir Seçimi': 'शहर चयन',
  'Şehir adı ara...': 'शहर का नाम खोजें...',
  'Aradığınız şehir bulunamadı': 'शहर नहीं मिला',
  'Bu ülke için şehir verisi bulunamadı': 'इस देश के लिए शहर डेटा उपलब्ध नहीं है',
  'şehir bulundu': '{{count}} शहर मिले',
  'Yetkili': 'अधिकृत व्यक्ति',
  'Telefon': 'फोन',
  'Email': 'ईमेल',
  'Bilgileri İlet': 'जानकारी भेजें',
  'Lütfen eksik alanları doldurun': 'कृपया खाली फ़ील्ड भरें',
  'Firma kaydedilemedi': 'कंपनी सहेजी नहीं जा सकी',
  'Firma bilgileri başarıyla iletildi': 'कंपनी जानकारी सफलतापूर्वक भेजी गई',
  'Firma Ünvanı:': 'कंपनी नाम:',
  'Yetkili Kişi:': 'अधिकृत व्यक्ति:',
  'Sepetiniz': 'आपकी कार्ट',
  'Sepetiniz boş': 'आपकी कार्ट खाली है',
  'adet': 'पीस',
  'Düzenle': 'संपादित करें',
  'Kaldır': 'हटाएं',
  'Siparişi Tamamla': 'ऑर्डर पूरा करें',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'कृपया पहले पूरी कंपनी जानकारी भेजें',
  'Sipariş başarıyla kaydedildi': 'ऑर्डर सफलतापूर्वक सहेजा गया',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'स्वागत संदेश और पहुंच लिंक आपके ईमेल पर भेजा गया',
  'Link 3 gün geçerlidir': 'लिंक 3 दिन के लिए मान्य है',
  'Sipariş kaydedilemedi': 'ऑर्डर सहेजा नहीं जा सका',
  'Firma Bilgileri Gerekli': 'कंपनी जानकारी आवश्यक',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'कार्ट में जोड़ने के लिए पहले कंपनी जानकारी भरें',
  'Önce Bilgileri Doldurun': 'पहले जानकारी भरें',
  'Uyarı': 'चेतावनी',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'कार्ट में जोड़ने के लिए आपको पहले कंपनी जानकारी भरनी होगी',
  'SUT Kütüphanesi Tanımı': 'एसयूटी लाइब्रेरी परिभाषा',
  'SUT Kodu:': 'एसयूटी कोड:',
  'Standart': 'मानक',
  'Açıklama (isteğe bağlı)': 'विवरण (वैकल्पिक)',
  'Partner Ol': 'पार्टनर बनें',
  'Partner başvuru popup açılacak': 'पार्टनर आवेदन पॉपअप खुलेगा',
  'Dil': 'भाषा',
  'E-posta': 'ईमेल',
  'globalPartnersTitle': 'दुनिया भर में 30,000 पार्टनर्स के साथ सहयोग',
  'globalPartnersDesc': '30,000 पार्टनर्स का हमारा विस्तृत वैश्विक नेटवर्क साझा नवाचार, ज्ञान साझाकरण और पारस्परिक सफलता को बढ़ावा देता है। साथ में, हम लगातार रोगी देखभाल की सीमाओं का विस्तार कर रहे हैं।',
  'bayiBasvuru': 'INVAMED पार्टनर आवेदन फॉर्म',
  'bayiBasvuruDesc': 'INVAMED पार्टनर नेटवर्क में शामिल होने के लिए नीचे दिया गया फॉर्म भरें। आपके आवेदन की समीक्षा के बाद हम आपसे संपर्क करेंगे।',
  'applyFields': {
    'firma': 'कंपनी नाम',
    'vergiNo': 'कर कार्यालय / पैन नंबर',
    'yetkili': 'अधिकृत व्यक्ति का पूरा नाम',
    'telefon': 'फोन',
    'email': 'ईमेल',
    'adres': 'पता',
    'sektor': 'गतिविधि क्षेत्र / क्षेत्र',
    'sicil': 'व्यावसायिक पंजीकरण संख्या',
    'web': 'वेबसाइट'
  },
  'Şifremi Unuttum': 'पासवर्ड भूल गए',
  'Demo Giriş': 'डेमो लॉगिन',
  'Bayi Başvurusu': 'पार्टनर आवेदन',
  'Yardım': 'सहायता',
  'Giriş yapılıyor...': 'लॉगिन हो रहा है...',
  'E-posta veya şifre hatalı': 'गलत ईमेल या पासवर्ड',
  'Şifre sıfırlama e-postası gönderildi': 'पासवर्ड रीसेट ईमेल भेजा गया',
  'E-posta gönderilemedi': 'ईमेल भेजा नहीं जा सका',
  'Vergi Dairesi / Vergi No': 'कर कार्यालय / पैन नंबर',
  'Yetkili Adı Soyadı': 'अधिकृत व्यक्ति का पूरा नाम',
  'Faaliyet Alanı / Sektör': 'गतिविधि क्षेत्र / क्षेत्र',
  'Ticaret Sicil No': 'व्यावसायिक पंजीकरण संख्या',
  'Web Sitesi': 'वेबसाइट',
  'Temel Bilgiler': 'बुनियादी जानकारी',
  'Ek Bilgiler': 'अतिरिक्त जानकारी',
  'Başvuru Gönder': 'आवेदन भेजें',
  'Başvuru gönderiliyor...': 'आवेदन भेज रहा है...',
  'Başvuru başarıyla gönderildi': 'आवेदन सफलतापूर्वक भेजा गया',
  'Başvuru gönderilemedi': 'आवेदन भेजा नहीं जा सका',
  'Sözleşme şartlarını kabul ediyorum': 'मैं अनुबंध की शर्तों को स्वीकार करता हूं',
  'Dosya Yükle': 'फ़ाइल अपलोड करें',
  'Dosya seçilmedi': 'कोई फ़ाइल चयनित नहीं',
  'Dosya yüklendi': 'फ़ाइल सफलतापूर्वक अपलोड की गई',
  'Dosya yüklenemedi': 'फ़ाइल अपलोड नहीं की जा सकी',
  'Tamamla': 'पूरा करें',
  'Geri': 'वापस',
  'İleri': 'आगे',
  'Kapat': 'बंद करें',
  'Yardım İçeriği': 'सहायता सामग्री',
  'dil': 'भाषा',
  'Üye Ol': 'साइन अप करें',
  'Üye Değil Misiniz?': 'सदस्य नहीं हैं?',
  'Şimdi Üye Ol': 'अभी साइन अप करें',
  'Misafir Kullanıcı': 'अतिथि उपयोगकर्ता',
  'Hızlı Sipariş': 'त्वरित ऑर्डर',
  'Misafir Olarak Sipariş Verin': 'अतिथि के रूप में ऑर्डर दें',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'लॉगिन किए बिना तुरंत अपने उत्पाद चुनें और अपना ऑर्डर बनाएं',
  'Giriş yapmadan sipariş oluşturun': 'लॉगिन किए बिना ऑर्डर बनाएं',
  'Anında Erişim': 'तत्काल पहुंच',
  'Tüm ürünlere anında erişim': 'सभी उत्पादों तक तत्काल पहुंच',
  'Güvenli İşlem': 'सुरक्षित लेन-देन',
  'SSL korumalı güvenli sipariş': 'SSL संरक्षित सुरक्षित ऑर्डर',
  'Misafir Olarak Sipariş Oluştur': 'अतिथि के रूप में ऑर्डर बनाएं',
  'İpucu:': 'सुझाव:',
  'Daha fazla özellik için üye olun': 'अधिक सुविधाओं के लिए साइन अप करें',
  'Ücretsiz': 'मुफ्त',
  'Hızlı': 'त्वरित',
  'Güvenli': 'सुरक्षित',
  'bayilikSozlesme': 'मैंने पार्टनरशिप की शर्तों और अनुबंध को पढ़ा और स्वीकार किया है।',
  'geri': 'वापस',
  'basvuruGonder': 'आवेदन भेजें',
  'ileri': 'आगे',
  'sozlesmeGonderildi': 'अनुबंध आपके ईमेल पर भेजा गया!',
  'sozlesmeDesc': 'कृपया आपके ईमेल पर भेजे गए INVAMED पार्टनरशिप अनुबंध और आवश्यक दस्तावेज़ अपलोड करें।',
  'tamamla': 'आवेदन पूरा करें',
  'basvuruAlindi': 'आपका आवेदन प्राप्त हो गया!',
  'basvuruAlindiDesc': 'INVAMED टीम आपके आवेदन की समीक्षा करेगी और जल्द से जल्द आपसे संपर्क करेगी।',
  'Başvuru Durumu': 'आवेदन स्थिति',
  'Başvurunuz onay sürecindedir': 'आपका आवेदन समीक्षाधीन है',
  'sifreSifirla': 'पासवर्ड रीसेट',
  'sifreSifirlaDesc': 'अपना पंजीकृत ईमेल दर्ज करें, हम पासवर्ड रीसेट निर्देश भेजेंगे।',
  'gonder': 'भेजें',
  'talimatGonderildi': 'निर्देश भेजे गए',
  'sentDesc': 'पासवर्ड रीसेट निर्देश <b>{email}</b> पर भेजे गए। कृपया अपना ईमेल जांचें।',
  'helpTitle': 'मैं कैसे लॉगिन कर सकता हूं?',
  'helpList': [
    'INVAMED पार्टनर पैनल में लॉगिन करने के लिए, अपना पंजीकृत ईमेल और पासवर्ड दर्ज करें।',
    'डेमो उपयोगकर्ता के साथ लॉगिन करने के लिए:',
    'यदि आप अपना पासवर्ड भूल गए हैं, तो आप "पासवर्ड भूल गए" लिंक के माध्यम से रीसेट का अनुरोध कर सकते हैं।',
    'यदि आपको लॉगिन में समस्या है, तो सुनिश्चित करें कि आप सही ईमेल और पासवर्ड दर्ज कर रहे हैं। यदि समस्या बनी रहती है, तो हमारी सहायता टीम से संपर्क करें।'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED पार्टनरशिप अनुबंध और शर्तें',
  'partnerlikSozlesmeText': `1. सामान्य प्रावधान

यह अनुबंध INVAMED (इसके बाद "कंपनी") और पार्टनर उम्मीदवार (इसके बाद "पार्टनर") के बीच चिकित्सा उपकरण और सामान की बिक्री में सहयोग के लिए किया गया है।

2. पार्टनरशिप की शर्तें

2.1. पार्टनर के पास चिकित्सा उपकरण की बिक्री के लिए कानूनी अधिकार होना चाहिए।
2.2. पार्टनर को स्वास्थ्य सेवा क्षेत्र में काम करने वाला संगठन होना चाहिए।
2.3. पार्टनर के पास आवश्यक लाइसेंस और प्रमाणपत्र होने चाहिए।
2.4. पार्टनर को वित्तीय रूप से विश्वसनीय होना चाहिए।

3. पक्षों के दायित्व

कंपनी के दायित्व:
3.1. उच्च गुणवत्ता वाले उत्पाद और सेवाएं प्रदान करना
3.2. तकनीकी सहायता प्रदान करना
3.3. प्रशिक्षण और जानकारी प्रदान करना
3.4. मूल्य निर्धारण में पारदर्शिता

पार्टनर के दायित्व:
3.1. उपयुक्त स्थितियों में उत्पादों का भंडारण
3.2. उच्च गुणवत्ता वाली ग्राहक सेवा प्रदान करना
3.3. कानूनी नियमों का पालन करना
3.4. कंपनी के ब्रांड की सुरक्षा करना

4. मूल्य निर्धारण और भुगतान

4.1. मूल्य कंपनी द्वारा निर्धारित किए जाते हैं
4.2. पार्टनर निर्धारित मूल्यों का पालन करने के लिए बाध्य है
4.3. भुगतान की शर्तें अलग से निर्धारित की जाती हैं
4.4. कमीशन दरें प्रदर्शन के आधार पर भिन्न हो सकती हैं

5. गोपनीयता और सुरक्षा

5.1. पक्ष एक-दूसरे की गोपनीय जानकारी की सुरक्षा के लिए बाध्य हैं
5.2. ग्राहक जानकारी को गोपनीय रखा जाना चाहिए
5.3. डेटा सुरक्षा मानकों का पालन करना चाहिए

6. अनुबंध की अवधि और समाप्ति

6.1. यह अनुबंध 1 वर्ष के लिए मान्य है
6.2. आपसी सहमति से बढ़ाया जा सकता है
6.3. 30 दिन की पूर्व सूचना के साथ समाप्त किया जा सकता है
6.4. गंभीर उल्लंघन के मामले में तुरंत समाप्त किया जा सकता है

7. विवाद समाधान

7.1. विवादों को पहले बातचीत के माध्यम से हल करने का प्रयास किया जाता है
7.2. जिन मामलों को हल नहीं किया जा सकता, उनमें तुरंत समाप्त किया जा सकता है

8. प्रभाव

यह अनुबंध पक्षों द्वारा पढ़ा, समझा और स्वीकार किया गया है। मैं घोषणा करता हूं कि मैं इस अनुबंध के सभी प्रावधानों को स्वीकार करता हूं और अपने दायित्वों का पालन करूंगा।`,
  'partnerlikSozlesmeOnay': 'मैंने ऊपर दिए गए INVAMED पार्टनरशिप अनुबंध और शर्तों को पढ़ा, समझा और स्वीकार किया है। मैं घोषणा करता हूं कि मैं इस अनुबंध के सभी प्रावधानों को स्वीकार करता हूं और अपने दायित्वों का पालन करूंगा।',
  'sozlesmeyiGoruntule': 'अनुबंध देखें',
  'sozlesmeyiKapat': 'बंद करें',
  'Ürün': 'उत्पाद',
  'Ürün eklemek için ürün listesinden seçim yapın': 'उत्पाद जोड़ने के लिए उत्पाद सूची से चयन करें',
  'Etiketler': 'टैग',
  'Öncelikli': 'प्राथमिकता',
  'Ülke Seçiniz': 'देश चुनें',
  'Firma / Sağlık Profesyoneli': 'कंपनी / स्वास्थ्य पेशेवर',
  'Şehir Seçiniz': 'शहर चुनें',
  'Yetkili Kişi': 'अधिकृत व्यक्ति',
  'UDI Kodu': 'यूडीआई कोड',
  'Teklif başarıyla kaydedildi!': 'ऑफर सफलतापूर्वक सहेजा गया!',
  'Aynı teklif zaten kayıtlı!': 'वही ऑफर पहले से ही सहेजा गया है!',
  'Kullanıcı adı veya şifre hatalı!': 'गलत उपयोगकर्ता नाम या पासवर्ड!',
  'Teklif No': 'ऑफर नंबर',
  'Teklifler': 'ऑफर',
  'Yedeklenecek teklif yok!': 'बैकअप के लिए कोई ऑफर नहीं!',
  'Yedek dosyası indirildi.': 'बैकअप फ़ाइल डाउनलोड की गई।',
  'Yedek başarıyla yüklendi.': 'बैकअप सफलतापूर्वक लोड किया गया।',
  'Geçersiz veya bozuk dosya!': 'अमान्य या क्षतिग्रस्त फ़ाइल!',
  'Yedekle (JSON)': 'बैकअप (JSON)',
  'Geri Yükle': 'पुनर्स्थापित करें',
  'Kayıtlı teklif yok.': 'कोई सहेजा गया ऑफर नहीं।',
  'E-posta Durumu': 'ईमेल स्थिति',
  'İşlemler': 'लेन-देन',
  'E-posta ile gönderildi': 'ईमेल द्वारा भेजा गया',
  'E-posta gönderilmedi': 'ईमेल नहीं भेजा गया',
  'Görüntüle': 'देखें',
  'Sil': 'हटाएं',
  'Gönderildi': 'भेजा गया',
  'Gönderilmedi': 'नहीं भेजा गया',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'ऑफर आईडी नहीं मिली! कृपया फिर से प्रयास करें।',
  'Lütfen partner seçiniz.': 'कृपया पार्टनर चुनें।',
  'Lütfen teslimat tarihi belirtiniz.': 'कृपया डिलीवरी तिथि निर्दिष्ट करें।',
  'Proforma başarıyla oluşturuldu!': 'प्रोफॉर्मा सफलतापूर्वक बनाया गया!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'प्रोफॉर्मा बनाया गया लेकिन उत्पाद जोड़ा नहीं जा सका। विवरण के लिए कंसोल जांचें।',
  'Link başarıyla silindi': 'लिंक सफलतापूर्वक हटाया गया',
  'Link kopyalandı!': 'लिंक कॉपी किया गया!',
  'Ödeme durumu başarıyla güncellendi!': 'भुगतान स्थिति सफलतापूर्वक अपडेट की गई!',
  'dosyası okunamadı!': 'फ़ाइल पढ़ी नहीं जा सकी!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'सभी फ़ाइलों के लिए एसयूटी कोड और मूल्य कॉलम चुनना होगा!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'लोड करने के लिए कोई वैध पंक्ति नहीं मिली! सुनिश्चित करें कि फ़ाइल में एसयूटी कोड और मूल्य से भरी पंक्तियां हैं।',
  'Yükleme sırasında hata oluştu!': 'लोडिंग के दौरान त्रुटि हुई!',
  'Otomatik etiket ekleme başarısız!': 'स्वचालित टैग जोड़ना विफल!',
  'Etiketler başarıyla güncellendi!': 'टैग सफलतापूर्वक अपडेट किए गए!',
  'Etiketler güncellenirken hata oluştu!': 'टैग अपडेट करते समय त्रुटि हुई!',
  'Resim başarıyla yüklendi!': 'छवि सफलतापूर्वक अपलोड की गई!',
  'Resim yüklendi ama ürün güncellenemedi!': 'छवि अपलोड की गई लेकिन उत्पाद अपडेट नहीं किया जा सका!',
  'Resim yüklenirken hata oluştu!': 'छवि अपलोड करते समय त्रुटि हुई!',
  'Ürün başarıyla güncellendi!': 'उत्पाद सफलतापूर्वक अपडेट किया गया!',
  'Ürün güncellenirken hata oluştu!': 'उत्पाद अपडेट करते समय त्रुटि हुई!',
  'Hata:': 'त्रुटि:',
  'Güncelleme hatası:': 'अपडेट त्रुटि:',
  'Alanlar yüklendi:': 'फ़ील्ड लोड किए गए:',
  'alan': 'फ़ील्ड',
  'Connect Free!': 'मुफ्त में कनेक्ट करें!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'हमारे सबसे लोकप्रिय उत्पादों की खोज करें',
  'Tüm Kategoriler': 'सभी श्रेणियां',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 उत्पाद दिखाए गए (कुल: 8000+)',
  'Tüm Ürünleri Gör →': 'सभी उत्पाद देखें →',
  'Detaylar': 'विवरण',
  'Sipariş Ver': 'अभी ऑर्डर करें',
  'Giriş Yap': 'लॉगिन',
  'Hesabınıza giriş yapın': 'अपने खाते में लॉगिन करें',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'यह साइट reCAPTCHA द्वारा संरक्षित है और Google की गोपनीयता नीति और सेवा की शर्तें लागू होती हैं।',
  'Ürün Kataloğumuz': 'हमारा उत्पाद कैटलॉग',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'हम 8000+ उत्पादों की विविधता प्रदान करते हैं',
  '1,3B': '1.3हजार',
  'Partner': 'साझेदार',
  '8,4M': '84लाख',
  'Toplam Üretim': 'कुल उत्पादन',
  '23': '23',
  'Branş': 'शाखा',
  '27,5B': '27.5हजार',
  'Toplam Sipariş': 'कुल ऑर्डर',
  'Connect Now': 'अभी कनेक्ट करें',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'सभी जानकारी तक एक जगह से पहुंचने के लिए मुफ्त में साइन अप करें।',
  'Ürün Detayları': 'उत्पाद विवरण',
  'Kapat': 'बंद करें',
  'Yükleniyor...': 'लोड हो रहा है...',
  'Hata': 'त्रुटि',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} उत्पाद दिखाए गए (कुल: 8000+)',
  'Şehir Seçimi': 'शहर चयन',
  'Firma / Sağlık Profesyoneli': 'कंपनी / स्वास्थ्य पेशेवर',
  'Yetkili Kişi': 'अधिकृत व्यक्ति',
  'Telefon': 'फोन',
  'E-posta': 'ईमेल',
  'E-Posta': 'ईमेल',
  'Temel Bilgiler': 'बुनियादी जानकारी',
  'Ek Bilgiler': 'अतिरिक्त जानकारी',
  'Faaliyet Alanı / Sektör': 'गतिविधि क्षेत्र / क्षेत्र',
  'Ülke Seçimi': 'देश चयन',
  'Ülke adı veya kodu ara...': 'देश का नाम या कोड खोजें...',
  'region.Avrupa': 'यूरोप',
  'region.Amerika': 'अमेरिका',
  'region.Asya': 'एशिया',
  'region.Afrika': 'अफ्रीका',
  'region.Okyanusya': 'ओशिआनिया',
  'region.Diğer': 'अन्य',
  'country.TR': 'तुर्की',
  'country.US': 'संयुक्त राज्य अमेरिका',
  'country.DE': 'जर्मनी',
  'country.FR': 'फ्रांस',
  'country.GB': 'यूनाइटेड किंगडम',
  'country.IT': 'इटली',
  'country.ES': 'स्पेन',
  'country.RU': 'रूस',
  'country.CN': 'चीन',
  'country.JP': 'जापान',
  'country.KR': 'दक्षिण कोरिया',
  'country.IN': 'भारत',
  'country.BR': 'ब्राजील',
  'country.CA': 'कनाडा',
  'country.AU': 'ऑस्ट्रेलिया',
  'Ticaret Sicil No': 'व्यापार पंजी संख्या',

  'country.TR': 'तुर्की',
  'country.AL': 'अल्बानिया',
  'country.DE': 'जर्मनी',
  'country.AD': 'अंडोरा',
  'country.AT': 'ऑस्ट्रिया',
  'country.BY': 'बेलारूस',
  'country.BE': 'बेल्जियम',
  'country.BA': 'बोस्निया और हर्जेगोविना',
  'country.BG': 'बुल्गारिया',
  'country.CZ': 'चेक गणराज्य',
  'country.DK': 'डेनमार्क',
  'country.EE': 'एस्टोनिया',
  'country.FO': 'फरो द्वीप',
  'country.FI': 'फिनलैंड',
  'country.FR': 'फ्रांस',
  'country.GI': 'जिब्राल्टर',
  'country.GR': 'ग्रीस',
  'country.GG': 'गर्न्सी',
  'country.HR': 'क्रोएशिया',
  'country.NL': 'नीदरलैंड',
  'country.IE': 'आयरलैंड',
  'country.ES': 'स्पेन',
  'country.SE': 'स्वीडन',
  'country.CH': 'स्विट्जरलैंड',
  'country.IT': 'इटली',
  'country.IS': 'आइसलैंड',
  'country.JE': 'जर्सी',
  'country.ME': 'मोंटेनेग्रो',
  'country.LV': 'लातविया',
  'country.LI': 'लिचटेंस्टीन',
  'country.LT': 'लिथुआनिया',
  'country.LU': 'लक्जमबर्ग',
  'country.HU': 'हंगरी',
  'country.MT': 'माल्टा',
  'country.IM': 'आइल ऑफ मैन',
  'country.MD': 'मोल्दोवा',
  'country.MC': 'मोनाको',
  'country.MK': 'उत्तरी मैसेडोनिया',
  'country.NO': 'नॉर्वे',
  'country.PL': 'पोलैंड',
  'country.PT': 'पुर्तगाल',
  'country.RO': 'रोमानिया',
  'country.RU': 'रूस',
  'country.SM': 'सैन मारिनो',
  'country.RS': 'सर्बिया',
  'country.SK': 'स्लोवाकिया',
  'country.SI': 'स्लोवेनिया',
  'country.SJ': 'स्वालबार्ड और जान मायेन',
  'country.UA': 'यूक्रेन',
  'country.GB': 'यूनाइटेड किंगडम',
  'country.VA': 'वेटिकन सिटी',
  'country.AX': 'ऑलैंड द्वीप',
  'country.US': 'संयुक्त राज्य अमेरिका',
  'country.AS': 'अमेरिकी समोआ',
  'country.AI': 'एंगुइला',
  'country.AG': 'एंटीगुआ और बारबुडा',
  'country.AR': 'अर्जेंटीना',
  'country.AW': 'अरूबा',
  'country.BS': 'बहामास',
  'country.BB': 'बारबाडोस',
  'country.BZ': 'बेलीज',
  'country.BM': 'बरमूडा',
  'country.BO': 'बोलीविया',
  'country.BR': 'ब्राजील',
  'country.VG': 'ब्रिटिश वर्जिन आइलैंड्स',
  'country.CA': 'कनाडा',
  'country.KY': 'केमैन आइलैंड्स',
  'country.CL': 'चिली',
  'country.CO': 'कोलंबिया',
  'country.CR': 'कोस्टा रिका',
  'country.CU': 'क्यूबा',
  'country.CW': 'कुराकाओ',
  'country.DM': 'डोमिनिका',
  'country.DO': 'डोमिनिकन गणराज्य',
  'country.EC': 'इक्वाडोर',
  'country.SV': 'एल साल्वाडोर',
  'country.FK': 'फॉकलैंड आइलैंड्स',
  'country.GF': 'फ्रेंच गुयाना',
  'country.GD': 'ग्रेनाडा',
  'country.GL': 'ग्रीनलैंड',
  'country.GP': 'ग्वाडेलूप',
  'country.GT': 'ग्वाटेमाला',
  'country.GY': 'गुयाना',
  'country.HT': 'हैती',
  'country.HN': 'होंडुरास',
  'country.JM': 'जमैका',
  'country.MQ': 'मार्टीनिक',
  'country.MX': 'मेक्सिको',
  'country.MS': 'मोंटसेराट',
  'country.NI': 'निकारागुआ',
  'country.PA': 'पनामा',
  'country.PY': 'पराग्वे',
  'country.PE': 'पेरू',
  'country.PR': 'प्यूर्टो रिको',
  'country.BL': 'सेंट बार्थेलेमी',
  'country.KN': 'सेंट किट्स और नेविस',
  'country.LC': 'सेंट लूसिया',
  'country.MF': 'सेंट मार्टिन',
  'country.PM': 'सेंट पियरे और मिकेलन',
  'country.VC': 'सेंट विंसेंट और ग्रेनाडाइन्स',
  'country.SX': 'सिंट मार्टेन',
  'country.SR': 'सूरीनाम',
  'country.TT': 'त्रिनिदाद और टोबैगो',
  'country.TC': 'तुर्क्स और कैकोस आइलैंड्स',
  'country.UY': 'उरुग्वे',
  'country.VE': 'वेनेजुएला',
  'country.VI': 'यू.एस. वर्जिन आइलैंड्स',
  'country.AF': 'अफगानिस्तान',
  'country.AZ': 'अजरबैजान',
  'country.BH': 'बहरीन',
  'country.BD': 'बांग्लादेश',
  'country.AE': 'संयुक्त अरब अमीरात',
  'country.BN': 'ब्रूनेई',
  'country.BT': 'भूटान',
  'country.CN': 'चीन',
  'country.TL': 'पूर्वी तिमोर',
  'country.ID': 'इंडोनेशिया',
  'country.AM': 'आर्मेनिया',
  'country.PH': 'फिलीपींस',
  'country.PS': 'फिलिस्तीन',
  'country.GE': 'जॉर्जिया',
  'country.KR': 'दक्षिण कोरिया',
  'country.IN': 'भारत',
  'country.HK': 'हांगकांग',
  'country.IQ': 'इराक',
  'country.IR': 'ईरान',
  'country.IL': 'इजराइल',
  'country.JP': 'जापान',
  'country.KH': 'कंबोडिया',
  'country.QA': 'कतर',
  'country.KZ': 'कजाकिस्तान',
  'country.KG': 'किर्गिस्तान',
  'country.CY': 'साइप्रस',
  'country.KW': 'कुवैत',
  'country.KP': 'उत्तर कोरिया',
  'country.LA': 'लाओस',
  'country.LB': 'लेबनान',
  'country.MO': 'मकाऊ',
  'country.MV': 'मालदीव',
  'country.MY': 'मलेशिया',
  'country.MM': 'म्यांमार',
  'country.MN': 'मंगोलिया',
  'country.NP': 'नेपाल',
  'country.UZ': 'उज्बेकिस्तान',
  'country.PK': 'पाकिस्तान',
  'country.SG': 'सिंगापुर',
  'country.LK': 'श्रीलंका',
  'country.SY': 'सीरिया',
  'country.SA': 'सऊदी अरब',
  'country.TJ': 'ताजिकिस्तान',
  'country.TH': 'थाईलैंड',
  'country.TW': 'ताइवान',
  'country.TM': 'तुर्कमेनिस्तान',
  'country.OM': 'ओमान',
  'country.JO': 'जॉर्डन',
  'country.VN': 'वियतनाम',
  'country.YE': 'यमन',
  'country.DZ': 'अल्जीरिया',
  'country.AO': 'अंगोला',
  'country.BJ': 'बेनिन',
  'country.BW': 'बोत्सवाना',
  'country.BF': 'बुर्किना फासो',
  'country.BI': 'बुरुंडी',
  'country.CV': 'कैप वर्डे',
  'country.CM': 'कैमरून',
  'country.CF': 'मध्य अफ्रीकी गणराज्य',
  'country.TD': 'चाड',
  'country.KM': 'कोमोरोस',
  'country.CG': 'कांगो गणराज्य',
  'country.CD': 'कांगो लोकतांत्रिक गणराज्य',
  'country.CI': 'आइवरी कोस्ट',
  'country.DJ': 'जिबूती',
  'country.EG': 'मिस्र',
  'country.GQ': 'इक्वेटोरियल गिनी',
  'country.ER': 'इरिट्रिया',
  'country.SZ': 'एस्वातिनी',
  'country.ET': 'इथियोपिया',
  'country.GA': 'गैबॉन',
  'country.GM': 'गाम्बिया',
  'country.GH': 'घाना',
  'country.GN': 'गिनी',
  'country.GW': 'गिनी-बिसाऊ',
  'country.KE': 'केन्या',
  'country.LS': 'लेसोथो',
  'country.LR': 'लाइबेरिया',
  'country.LY': 'लीबिया',
  'country.MG': 'मेडागास्कर',
  'country.MW': 'मलावी',
  'country.ML': 'माली',
  'country.MR': 'मॉरिटानिया',
  'country.MU': 'मॉरीशस',
  'country.YT': 'मायोट',
  'country.MA': 'मोरक्को',
  'country.MZ': 'मोजाम्बिक',
  'country.NA': 'नामीबिया',
  'country.NE': 'नाइजर',
  'country.NG': 'नाइजीरिया',
  'country.RE': 'रेयूनियन',
  'country.RW': 'रवांडा',
  'country.SH': 'सेंट हेलेना',
  'country.ST': 'साओ टोमे और प्रिंसिपे',
  'country.SN': 'सेनेगल',
  'country.SC': 'सेशेल्स',
  'country.SL': 'सिएरा लियोन',
  'country.SO': 'सोमालिया',
  'country.ZA': 'दक्षिण अफ्रीका',
  'country.SS': 'दक्षिण सूडान',
  'country.SD': 'सूडान',
  'country.TZ': 'तंजानिया',
  'country.TG': 'टोगो',
  'country.TN': 'ट्यूनीशिया',
  'country.UG': 'युगांडा',
  'country.EH': 'पश्चिमी सहारा',
  'country.ZM': 'जाम्बिया',
  'country.ZW': 'जिम्बाब्वे',
  'country.AU': 'ऑस्ट्रेलिया',
  'country.CX': 'क्रिसमस आइलैंड',
  'country.CC': 'कोकोस आइलैंड्स',
  'country.CK': 'कुक आइलैंड्स',
  'country.FJ': 'फिजी',
  'country.PF': 'फ्रेंच पोलिनेशिया',
  'country.GU': 'गुआम',
  'country.HM': 'हर्ड आइलैंड और मैकडोनाल्ड आइलैंड्स',
  'country.KI': 'किरिबाती',
  'country.MH': 'मार्शल आइलैंड्स',
  'country.FM': 'माइक्रोनेशिया',
  'country.NR': 'नाउरू',
  'country.NC': 'न्यू कैलेडोनिया',
  'country.NZ': 'न्यूजीलैंड',
  'country.NU': 'नीयू',
  'country.NF': 'नॉरफॉक आइलैंड',
  'country.MP': 'उत्तरी मारियाना आइलैंड्स',
  'country.PW': 'पलाऊ',
  'country.PG': 'पापुआ न्यू गिनी',
  'country.PN': 'पिटकेर्न आइलैंड्स',
  'country.WS': 'समोआ',
  'country.SB': 'सोलोमन आइलैंड्स',
  'country.TK': 'टोकेलाऊ',
  'country.TO': 'टोंगा',
  'country.TV': 'तुवालू',
  'country.VU': 'वानुआटू',
  'country.WF': 'वालिस और फुटुना',
  'country.AQ': 'अंटार्कटिका',
  'country.BV': 'बोउवेट आइलैंड',
  'country.IO': 'ब्रिटिश इंडियन ओशन टेरिटरी',
  'country.TF': 'फ्रेंच सदर्न टेरिटरीज',
  'country.GS': 'साउथ जॉर्जिया और साउथ सैंडविच आइलैंड्स',
};
